/**
 * Keyboard input bindings.
 * Each action maps to an array of KeyboardEvent.code values.
 */
export const INPUT_CONFIG = {
  forward:  ['ArrowUp', 'KeyW'],
  backward: ['ArrowDown', 'KeyS'],
  left:     ['ArrowLeft', 'KeyA'],
  right:    ['ArrowRight', 'KeyD'],
  brake:    ['Space'],
  cameraModeAvatar: ['Digit1'],
  cameraModeCar:    ['Digit2'],
};
